import { Link } from 'react-router-dom';
import { SITE } from '@/mocks/site';
import { CATEGORIES } from '@/mocks/categories';
import NewsletterForm from '@/components/feature/NewsletterForm';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-foreground-900 border-t border-background-300/40">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-secondary-950 text-xl font-heading">
                黑
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl text-foreground-950">{SITE.name}</span>
                <span className="text-[10px] tracking-[0.28em] text-primary-500 mt-1">
                  {SITE.englishName}
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm text-foreground-700 leading-relaxed max-w-md">
              {SITE.intro}
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-xs text-foreground-600">
              <span className="px-3 py-1.5 rounded-full border border-background-300/50">
                {SITE.location}
              </span>
              <span className="px-3 py-1.5 rounded-full border border-background-300/50">
                {SITE.since}
              </span>
            </div>
          </div>

          <nav className="lg:col-span-3" aria-label="档案分类导航">
            <h2 className="font-heading text-base text-foreground-950 mb-4">档案分类</h2>
            <ul className="space-y-2.5">
              {CATEGORIES.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/archive?category=${cat.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-4">
            <h2 className="font-heading text-base text-foreground-950 mb-4">线索订阅</h2>
            <NewsletterForm />
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5">
            <p className="text-xs text-foreground-600">
              © {year} {SITE.name}. 内容仅为网络文化记录与考据。
            </p>
            <p className="text-xs text-foreground-600">
              线索投递：
              <a
                href={`mailto:${SITE.submitEmail}`}
                className="text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer"
              >
                {SITE.submitEmail}
              </a>
            </p>
          </div>
          <div className="flex items-center gap-4 text-lg text-foreground-600">
            <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-300/50">
              <i className="ri-mail-line"></i>
            </span>
            <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-300/50">
              <i className="ri-archive-2-line"></i>
            </span>
            <span className="text-xs px-3 py-1.5 rounded-full stamp-tag whitespace-nowrap">
              {SITE.social}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}